import {
    BRANDED_EGIFT,
    CARD_LINK,
    CHANGE_BRAND,
    PLASTIC_REDEMPTION,
    UNBRANDED_TO_EGIFT,
    UNBRANDED_TO_LINK,
} from '@/src/modules/pg-plus/constants'
import {
    ADDRESS_ENTRY_STEP,
    GIFT_DETAILS_STEP,
    SELECT_BRAND_STEP,
    SUCCESS_STEP,
} from '@/src/modules/pg-plus/redemption/constants'
import {
    DISPATCH_CARD_LINK_MODAL,
    DISPATCH_CHANGE_BRAND_MODAL,
    DISPATCH_REDEEM_PLASTIC_MODAL,
    DISPATCH_SET_STEP,
    DISPATCH_UNBRANDED_TO_EGIFT,
    DISPATCH_UNBRANDED_TO_LINK,
} from '@/src/common/reducers/constants'

type TStepProps = {
    selection: string
    dispatch: any
    pushToSuccessStep?: boolean
}

export function handleSteps({
    selection,
    dispatch,
    pushToSuccessStep = false,
}: TStepProps) {
    const requiresChangeBrand: boolean = [
        UNBRANDED_TO_LINK,
        UNBRANDED_TO_EGIFT,
        CHANGE_BRAND,
    ].includes(selection)

    if (requiresChangeBrand) {
        return dispatch({
            type: DISPATCH_SET_STEP,
            payload: { stepName: SELECT_BRAND_STEP },
        })
    }

    switch (selection) {
        case CARD_LINK:
            dispatch({
                type: DISPATCH_SET_STEP,
                payload: {
                    stepName: pushToSuccessStep
                        ? SUCCESS_STEP
                        : GIFT_DETAILS_STEP,
                },
            })
            return
        case BRANDED_EGIFT:
            dispatch({
                type: DISPATCH_SET_STEP,
                payload: { stepName: SUCCESS_STEP },
            })
            return
        case PLASTIC_REDEMPTION:
            dispatch({
                type: DISPATCH_SET_STEP,
                payload: { stepName: ADDRESS_ENTRY_STEP },
            })
            return
        default:
            return
    }
}

export function startsWithAVowel(string: string | null) {
    if (!!string) {
        return Boolean(/[aeiou]/i.test(string[0]))
    }
    return false
}

export function determineModalType(selection: string) {
    const requiresChangeBrand: boolean = [BRANDED_EGIFT, CHANGE_BRAND].includes(
        selection
    )

    if (requiresChangeBrand) {
        return DISPATCH_CHANGE_BRAND_MODAL
    }

    switch (selection) {
        case CARD_LINK:
            return DISPATCH_CARD_LINK_MODAL
        case PLASTIC_REDEMPTION:
            return DISPATCH_REDEEM_PLASTIC_MODAL
        case UNBRANDED_TO_LINK:
            return DISPATCH_UNBRANDED_TO_LINK
        case UNBRANDED_TO_EGIFT:
            return DISPATCH_UNBRANDED_TO_EGIFT
        default:
            return ''
    }
}
